import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import React from 'react';

import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';
import { safeDecodeURIComponent } from '@/utils/displayIdentifier.util';

export function renderDataFindingPII(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { dataFindingExamplesArray, processedKeys } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (
    dataFindingExamplesArray &&
    dataFindingExamplesArray.length > 0 &&
    mainTabKeys.includes('DETECTION')
  ) {
    const piiArray = dataFindingExamplesArray;
    sections['wiz_data_finding_examples'] = (
      <div className="space-y-4">
        <div className="border-error border-l-4 p-4">
          <div className="flex items-center">
            <ShieldExclamationIcon className="text-error mr-2 size-5" />
            <h4 className="text-chariot-text-primary font-semibold">
              PII Data Finding Examples
            </h4>
          </div>
        </div>

        <div className="border-chariot-stroke rounded-lg border p-4">
          <div className="mb-3 flex items-center justify-between">
            <span className="text-chariot-text-secondary font-medium">
              Detected PII Values:
            </span>
            <span className="text-chariot-text-tertiary text-xs">
              {piiArray.length} total matches
            </span>
          </div>
          <div className="bg-chariot-background-secondary rounded-lg p-3">
            <div className="text-chariot-text-secondary mb-2 text-xs">
              Sample findings (showing first 10):
            </div>
            <div className="space-y-2">
              {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
              {piiArray.slice(0, 10).map((item: any, idx: number) => (
                <div
                  key={idx}
                  className="border-chariot-stroke border-b pb-2 last:border-b-0"
                >
                  <div className="mb-1 flex items-center justify-between">
                    <code className="text-chariot-text-primary font-mono text-sm">
                      {item.value || item.valueForAnalytics || 'Unknown'}
                    </code>
                    {item.pathTotalMatches && (
                      <span className="text-chariot-text-tertiary text-xs">
                        {item.pathTotalMatches.Value || item.pathTotalMatches}{' '}
                        matches
                      </span>
                    )}
                  </div>
                  {item.path && (
                    <div className="text-chariot-text-tertiary text-xs break-all">
                      {safeDecodeURIComponent(item.path)}
                    </div>
                  )}
                </div>
              ))}
              {piiArray.length > 10 && (
                <div className="border-chariot-stroke text-chariot-text-secondary border-t pt-2 text-xs italic">
                  ... and {piiArray.length - 10} more findings
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
    tempTabs['DETECTION'].push({
      label: 'PII Findings',
      value: 'wiz_data_finding_examples',
    });
    processedKeys.push('Data Finding Examples');
  }
}
